export const buildApplyUrl = (serviceTitle = '') => {
  if (!serviceTitle) {
    return '/apply';
  }

  return `/apply?service=${encodeURIComponent(serviceTitle)}`;
};

const getDefaultApiBaseUrl = () => {
  const host = typeof window !== 'undefined' ? window.location.hostname : '';
  if (host === 'localhost' || host === '127.0.0.1') {
    return 'http://127.0.0.1:8000';
  }

  return 'https://laftekbusinesssolutions.com/api';
};

export const apiBaseUrl = process.env.REACT_APP_API_BASE_URL || getDefaultApiBaseUrl();

export const slides = [
  {
    badge: 'Career Development Firm',
    title: 'We Support You to Build Your Career',
    titleHighlight: 'Build Your Career',
    typingWords: ['Career', 'Confidence', 'Future'],
    desc: 'Laftek Business Solutions helps candidates at every stage, from freshers to laterals. Placement support, resume coaching, salary negotiation, and more.',
    btn1: { label: 'Our Services', href: '/services' },
    btn2: { label: 'Contact Us', href: '/contact' },
    bg: '#ffffff',
    bg2: '#eaf4ff',
    visualCards: [
      { title: 'Career Roadmap', subtitle: 'Resume, interview, offer strategy', tone: 'blue' },
      { title: 'Candidate Support', subtitle: 'Freshers to laterals', tone: 'coral' },
      { title: 'Placement Guidance', subtitle: 'Right role, right timing', tone: 'mint' },
    ],
  },
  {
    badge: 'Job Placement Support',
    title: 'Fresher & Lateral Job Placement',
    titleHighlight: 'Fresher & Lateral',
    typingWords: ['Placements', 'Openings', 'Interviews'],
    desc: "Whether you're just starting out or have years of experience, we connect you with the right MNC opportunities and preferred technology roles.",
    btn1: { label: 'Apply Now', href: buildApplyUrl('Lateral Job Support') },
    btn2: { label: 'View Openings', href: '/jobs' },
    bg: '#fdfefe',
    bg2: '#eef8f2',
    visualCards: [
      { title: 'Resume Shortlist', subtitle: 'Profile matched to demand', tone: 'blue' },
      { title: 'Interview Call', subtitle: 'Live opportunities this week', tone: 'coral' },
      { title: 'MNC Roles', subtitle: 'Support, cloud, delivery, dev', tone: 'mint' },
    ],
  },
  {
    badge: 'AI & The Future of Work',
    title: 'Will AI Replace Your Job?',
    titleHighlight: 'AI Replace',
    typingWords: ['AI Skills', 'Human Edge', 'Upskilling'],
    desc: 'AI is changing the job market, but not the way you think. Learn why upskilling now is your biggest competitive advantage.',
    btn1: { label: 'Learn More', href: '/ai-careers' },
    btn2: { label: 'Get Upskilled', href: buildApplyUrl('Training Support') },
    bg: '#ffffff',
    bg2: '#f6f2ff',
    visualCards: [
      { title: 'AI Readiness', subtitle: 'Learn tools employers expect', tone: 'blue' },
      { title: 'Human Judgment', subtitle: 'Communication and leadership', tone: 'coral' },
      { title: 'New Roles', subtitle: 'Prompting, audit, AI operations', tone: 'mint' },
    ],
  },
  {
    badge: 'Certifications & Skills',
    title: 'Get Certified & Stay Ahead of the Market',
    titleHighlight: 'Stay Ahead',
    typingWords: ['Certifications', 'DevOps', 'Cloud'],
    desc: 'We train you with the latest certification dumps and ensure you clear any certification in under a week. Stay relevant, stay hired.',
    btn1: { label: 'Certification Support', href: '/services' },
    btn2: { label: 'Contact Us', href: '/contact' },
    bg: '#ffffff',
    bg2: '#fff4ea',
    visualCards: [
      { title: 'Fast Track Prep', subtitle: 'Focused support in under a week', tone: 'blue' },
      { title: 'Cloud Skills', subtitle: 'Certifications aligned to demand', tone: 'coral' },
      { title: 'Market Ready', subtitle: 'Updated skills, stronger profile', tone: 'mint' },
    ],
  },
];

export const services = [
  { num: '01', icon: 'Learn', title: 'Freshers Job Support', desc: 'Kickstart your career at top MNCs with the best fresher offers.' },
  { num: '02', icon: 'Grow', title: 'Lateral Job Support', desc: 'Turn your experience into your next opportunity.' },
  { num: '03', icon: 'Open', title: 'Open Job Support', desc: 'Find the perfect role in your preferred technology.' },
  { num: '04', icon: 'Tech', title: 'Technical Job Support', desc: 'Strengthen your skills with expert-led guidance.' },
  { num: '05', icon: 'Cert', title: 'Certification Support', desc: 'Clear your certification with confidence and expert support.' },
  { num: '06', icon: 'Start', title: 'Internship Support', desc: 'Start as an intern, stand out as a professional.' },
  { num: '07', icon: 'Prep', title: 'Interview Support', desc: 'Turn interview challenges into job offers.' },
  { num: '08', icon: 'Train', title: 'Training Support', desc: 'Build your skills, unlock opportunities, shape your future.' },
  { num: '09', icon: 'Pay', title: 'Payroll Support', desc: 'We support your payroll journey until you land your dream job.' },
  { num: '10', icon: 'Docs', title: 'Documentation Support', desc: 'Complete document support, every step of the way.' },
];

export const aiCards = [
  { icon: 'AI', title: 'AI Automates Repetitive Tasks', desc: 'Data entry, basic coding, and customer Q&A are increasingly handled by AI. If your role is purely repetitive, it is at risk.' },
  { icon: 'Skill', title: 'AI Cannot Replace Human Judgment', desc: 'Critical thinking, leadership, emotional intelligence, negotiation, and creative problem-solving remain deeply human strengths.' },
  { icon: 'Growth', title: 'New Jobs Are Being Created', desc: 'Every AI tool needs a human to prompt, audit, and manage it. AI Trainer, Prompt Engineer, and AI Supervisor are growing roles.' },
  { icon: 'Ready', title: 'Upskilling Is Your Shield', desc: 'Workers who learn to work with AI are replacing those who compete against it. Certifications in cloud, data, or DevOps keep you valuable.' },
];
